import ArrowLeftIcon from '@/fo/icons/base/icons/arrow24.svg';
import { MenuItem } from '@/fo/ui/app/menu/base';

import { Items } from '../Items/Items';

import { styles } from './NestedScreen.styles';

export interface NavigationLevel {
  items: MenuItem[];
  index: number;
  title: string;
}

export interface NestedScreenProps {
  navigationHistory: NavigationLevel[];
  additionalItems: MenuItem[];
  onBackClick: () => void;
  onMenuItemClick: (items: MenuItem[], index: number, title: string) => void;
}

export function NestedScreen({
  navigationHistory,
  additionalItems,
  onBackClick,
  onMenuItemClick
}: NestedScreenProps) {
  const slots = styles();

  if (navigationHistory.length === 0) return null;

  const currentLevel = navigationHistory[navigationHistory.length - 1];
  const selectedItem = currentLevel.items[currentLevel.index];

  if (!selectedItem || !selectedItem.children) return null;

  const isCatalog = navigationHistory.length === 1 && currentLevel.index === 0;

  return (
    <div className={slots.base()}>
      <button
        className={slots.backButton()}
        onClick={onBackClick}
      >
        <ArrowLeftIcon className="rotate-180" />
        <span>{currentLevel.title}</span>
      </button>

      {isCatalog && (
        <div className={slots.group()}>
          <Items
            items={additionalItems}
            props={(item, index) => ({
              onClick: () => onMenuItemClick(additionalItems, index, item.label)
            })}
          />
        </div>
      )}

      <Items
        items={selectedItem.children}
        props={(item, index) => ({
          onClick: () =>
            onMenuItemClick(selectedItem.children || [], index, item.label)
        })}
      />
    </div>
  );
}
